/**
 * @name styles
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Estilos compartilhados para os componentes do menu lateral.
 * @package src/components/layouts/UserLayout/components/UserSideBar/styles.ts
 **/

import { Theme } from '@mui/material';

export const createDrawerStyles = (theme: Theme, drawerWidth: number) => {
  // Define o estilo do menuItem uma vez para evitar chamadas recursivas
  const menuItemStyle = (isActive: boolean) => ({
    backgroundColor: isActive ? theme.palette.divider : 'transparent',
    color: isActive ? theme.palette.text.primary : theme.palette.text.secondary,
  });
  
  return {
    drawer: {
      '& .MuiDrawer-paper': {
        boxSizing: 'border-box',
        width: drawerWidth,
        height: 'calc(100%)',
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        borderRight: `1px solid ${theme.palette.divider}`,
        '&::-webkit-scrollbar': {
          width: '0.4em',
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: `inset 0 0 6px ${theme.palette.background.paper}`,
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.divider,
          outline: `1px solid ${theme.palette.background.paper}`,
          '&:hover': {
            backgroundColor: theme.palette.divider,
          },
        },
      },
    },
    menuItem: menuItemStyle,
    nestedMenuItem: (isActive: boolean, level: number) => ({
      pl: level === 1 ? 2 : 8 + (level - 1) * 6, 
      ...menuItemStyle(isActive),
    }),
  };
};
